import _ from 'lodash'
const removeDraftAnnotations = item => {
    delete item._isDraftItem
    delete item._draftRefs
}

const addDraftAnnotations = (ps, namespace: string, dataItem) => {
    if (ps.extensionAPI.schemaAPI.isDraftDataSchema(namespace, dataItem.type)) {
        dataItem._isDraftItem = true
        const refInfos = ps.extensionAPI.schemaAPI.extractReferenceFieldsInfo(namespace, dataItem.type, dataItem)
        if (refInfos?.length) {
            dataItem._draftRefs = _.map(refInfos, info => _.pick(info, ['jsonPointer', 'path']))
        }
    }
}

export default {
    removeDraftAnnotations,
    addDraftAnnotations
}
